import React from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { documentCardSx, terminalBarIconButtonSx } from '../../theme/terminalStyles';

const CARD_ACTION_SIZE = 36;
const CARD_STATUS_DOT_SIZE = 24;

const StocktakeDocumentCard = ({ stocktake, statusColor, onOpen }) => {
  const dateStr = stocktake.date ? new Date(stocktake.date).toLocaleDateString('uk-UA') : '—';
  const title = stocktake.fromERP
    ? stocktake.number || String(stocktake.id)
    : String(stocktake.id);
  const warehouseName = stocktake.warehouse?.name || '—';
  const userName = stocktake.user?.name || stocktake.user?.login || '—';
  const commentText = stocktake.comment?.trim?.() ? String(stocktake.comment).trim() : '';
  const isDone = Boolean(stocktake.isDone);

  return (
    <Paper sx={documentCardSx} elevation={0}>
      <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1.5 }}>
        <Box
          sx={{
            width: CARD_ACTION_SIZE,
            minWidth: CARD_ACTION_SIZE,
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 0.25,
          }}
        >
          <IconButton
            onClick={onOpen}
            aria-label={isDone ? 'переглянути' : 'відкрити'}
            sx={{
              ...terminalBarIconButtonSx,
              width: CARD_ACTION_SIZE,
              height: CARD_ACTION_SIZE,
              minWidth: CARD_ACTION_SIZE,
              minHeight: CARD_ACTION_SIZE,
            }}
          >
            {isDone ? <LockOutlinedIcon /> : <PlayArrowIcon />}
          </IconButton>
          <Box
            aria-hidden
            sx={{
              width: CARD_STATUS_DOT_SIZE,
              height: CARD_STATUS_DOT_SIZE,
              borderRadius: '50%',
              bgcolor: statusColor,
              flexShrink: 0,
              ...(!isDone ? { border: '1px solid rgba(0, 0, 0, 0.12)' } : {}),
            }}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} noWrap>
            {stocktake.fromERP ? `№ ${title}` : `# ${title}`}
            {!stocktake.fromERP ? (
              <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                локальний
              </Typography>
            ) : null}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {dateStr}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }} noWrap title={warehouseName}>
            {warehouseName}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }} noWrap title={userName}>
            {userName}
          </Typography>
          {commentText ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.5 }}
              noWrap
              title={commentText}
            >
              {commentText}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Paper>
  );
};

export default StocktakeDocumentCard;
